import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../shared/shared.module';
import { RegisterComponent } from './register/register.component';
import { RecoverComponent } from './password-recovery/recover.component';
import { LockComponent } from './lock/lock.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { Error404Component } from './error404/error404.component';
import { Error500Component } from './error500/error500.component';
import { LoginComponent } from "../login/login.component";
import { ResetPasswordComponent } from './password-recovery/reset-password.component';
import { SsoLogoutComponent } from "@app/routes/pages/sso-logout/sso-logout.component";

/* Use this routes definition in case you want to make them lazy-loaded */
/*const routes: Routes = [
    { path: 'login', component: LoginComponent },
    { path: 'register', component: RegisterComponent },
    { path: 'recover', component: RecoverComponent },
    { path: 'lock', component: LockComponent },
    { path: 'maintenance', component: MaintenanceComponent },
    { path: '404', component: Error404Component },
    { path: '500', component: Error500Component },
];*/

@NgModule({
  imports: [
    SharedModule
    // RouterModule.forChild(routes)
  ],
  declarations: [
    LoginComponent,
    RegisterComponent,
    RecoverComponent,
    ResetPasswordComponent,
    LockComponent,
    MaintenanceComponent,
    Error404Component,
    Error500Component,
    SsoLogoutComponent
  ],
  exports: [
    RouterModule,
    LoginComponent,
    RegisterComponent,
    RecoverComponent,
    ResetPasswordComponent,
    LockComponent,
    MaintenanceComponent,
    Error404Component,
    Error500Component
  ]
})
export class PagesModule {
}
